// The single definition of the "read Linear uncached" contract, shared by both halves so the wire format
// cannot drift: `requestedDirectoryRead` is how every selector endpoint derives the flag, and `withRefresh`
// (shared/web/client.ts) is how every client sends it.
//
// Uncached directory reads are opt-in per request. An ordinary selector load must read the TTL cache so
// concurrent loads share one in-flight fetch per key; only a picker's explicit Refresh pays for uncached
// user + membership + workspace pagination.
export const LINEAR_DIRECTORY_REFRESH_PARAM = "refresh";
export const LINEAR_DIRECTORY_REFRESH_VALUE = "1";

type RefreshQueryReader = {
  query: (name: string) => string | undefined;
};

export const requestedDirectoryRead = (request: RefreshQueryReader): { fresh: boolean } => ({
  fresh: request.query(LINEAR_DIRECTORY_REFRESH_PARAM) === LINEAR_DIRECTORY_REFRESH_VALUE,
});
